import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useShop } from '../../context/ShopContext';

const { FiX, FiCheckCircle } = FiIcons;

const RegistryModal = () => {
  const { isRegistryOpen, setIsRegistryOpen } = useShop();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setStep(2);
    }, 1500);
  };

  return (
    <AnimatePresence>
      {isRegistryOpen && (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-6">
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsRegistryOpen(false)}
            className="absolute inset-0 bg-black/40 backdrop-blur-md"
          />
          <motion.div 
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            className="relative bg-luma-bg w-full max-w-lg rounded-[40px] overflow-hidden shadow-2xl p-8 md:p-12"
          >
            <button 
              onClick={() => setIsRegistryOpen(false)}
              className="absolute top-6 right-6 p-2 hover:bg-luma-sand/20 rounded-full transition-colors"
            >
              <SafeIcon icon={FiX} className="text-xl" />
            </button>

            {step === 1 ? (
              <div className="space-y-8">
                <div className="text-center">
                  <span className="text-luma-primary text-[10px] font-bold tracking-[0.3em] uppercase mb-4 block">New Chapter</span>
                  <h2 className="font-serif text-3xl md:text-4xl text-luma-text">Start your workspace experience.</h2>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="space-y-2">
                    <label className="text-[10px] uppercase tracking-widest font-bold text-luma-text/40 ml-1">Parent Name</label>
                    <input 
                      required
                      type="text" 
                      placeholder="Your full name"
                      className="w-full bg-white border border-luma-sand rounded-2xl px-6 py-4 focus:outline-none focus:border-luma-primary transition-colors"
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="text-[10px] uppercase tracking-widest font-bold text-luma-text/40 ml-1">Expected Arrival</label>
                    <input 
                      required
                      type="date" 
                      className="w-full bg-white border border-luma-sand rounded-2xl px-6 py-4 focus:outline-none focus:border-luma-primary transition-colors"
                    />
                  </div>
                  <button 
                    disabled={loading}
                    className="w-full bg-luma-text text-white py-5 rounded-full text-xs font-bold tracking-widest uppercase hover:bg-luma-primary transition-all disabled:opacity-50"
                  >
                    {loading ? 'Creating Experience...' : 'Create Registry'}
                  </button>
                </form>
              </div>
            ) : (
              <motion.div 
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                className="text-center py-12 space-y-6"
              >
                <div className="w-20 h-20 bg-green-50 text-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={FiCheckCircle} className="text-4xl" />
                </div>
                <h2 className="font-serif text-3xl">Your journey begins.</h2>
                <p className="text-luma-text/60 leading-relaxed">
                  Welcome to the LumaBaby village. Your personalized workspace has been created. Check your email for your welcome box details.
                </p>
                <button 
                  onClick={() => setIsRegistryOpen(false)}
                  className="w-full bg-luma-text text-white py-5 rounded-full text-xs font-bold tracking-widest uppercase hover:bg-luma-primary transition-all"
                >
                  Start Exploring
                </button>
              </motion.div>
            )}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default RegistryModal;